<template>
  <div class="w100">
    <div class="footer">
      <div class="bgColor">
    <div class="f1 h30">
      <span class="w40"><span class="leftTitle">主办单位</span><span class="rightFont">中华国际科学交流基金会</span></span>
      <span class="w40"><span class="leftTitle">咨询电话</span><span class="rightFont">010-88653180</span></span>
      <span class="w30"><span class="leftTitle">咨询邮箱</span><span class="rightFont">stsc@isefc.org</span></span>
    </div>
    <div class="f1 h30">
      <span class="w40"><span class="leftTitle">联合主办</span><span class="rightFont">中关村天合科技成果转化促进中心</span></span>
      <span class="w40"><span class="leftTitle">技术支持</span><span class="rightFont">北京华科软通科技有限公司</span></span>
      <span class="w30"><span class="leftTitle">备案号</span><span class="rightFont">京ICP备16027592号-3</span></span>

    </div>

    </div >
    </div>


<!-- <div class="copyRight"><span class="copyRightText">Copyright  ©  2026   <span class="support">技术支持：北京华科软通科技有限公司</span>   京ICP备16027592号-3</span></div> -->



  </div>
</template>

<script>
export default {
  name: 'Playbar',
  data() {
    return {
      aboutInfo:{},
      audio: [
        {

        }
      ],

    }
  },
  mounted() {
  },
  methods:{
    goPrivacyPolicy(){
  this.$router.push({path:'/PrivacyPolicy'})

    },
      getInfo(){
        // this.$API.getAbout().then(res=>{
        //     this.aboutInfo = res.model
        // })
    },
  }
}
</script>

<style scoped lang="less">
.support{
  margin: 0 15px;
}
.copyRightText{
font-family: SourceHanSansCN-Light, SourceHanSansCN-Light;
font-weight: normal;
font-size: 12px;
color: #FFFFFF;
opacity: .2;
}
.copyRight{
  width: 100%;
height: 54px;
background: #03224E;
border-radius: 0px 0px 0px 0px;
text-align: center;
line-height: 54px;
}
.w100{
  width: 100%;
}
.rightFont{
opacity: .5;
}
.leftTitle{
  width: 56px;
height: 19px;
font-family: Source Han Sans CN, Source Han Sans CN;
font-weight: 400;
font-size: 14px;
color: #FFFFFF;
margin-right: 20px;
opacity: .7;
}
.bgColor{
  width: 1200px;
  margin: 0 auto;
  color: #D0D2DD;
    span{
      float: left;
    }
    .ml91{
      margin-left: 91px;
    }
    .ml20{
      margin-left: 20px;
    }
    .ml33{
      margin-left: 34px;
    }
    .ml15{
      margin-left: 20px;
    }
    .h30{
      height: 30px;
    }
}

.w40{
  width: 30%;
}
.w30{
  width: 20%;
}
.f1{
  display: flex;
  justify-content: space-around;
}
.footer{
  width: 100%;
  background: #001b41;
  font-size: 14px;
  padding: 15px 0;
}
</style>